module.exports = __webpack_public_path__ + "img/individual-meter-water-meter-hot-md.ed4bc27d.svg";